export default {
  SET_DPR: (state, payload) => (state.dpr = payload),
  SET_DPR_FILES: (state, payload) => (state.dprFiles = payload),
  SET_CURRENT_DPR_MAIN_ID: (state, payload) => (state.currentDprMainId = payload),
  SET_CURRENT_DPR_PV_ID: (state, payload) => (state.currentPVId = payload),

  RESET_DPR_CONTEXT: (state) => {
    state.dpr = null;
    state.dprFiles = [];
    state.currentDprMainId = null;
    state.currentPVId = null;

    delete sessionStorage.currentDpr;
    delete sessionStorage.currentDprHeader;
  },
};
